import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
@Injectable({
  providedIn:"root"
})
export class RoutingRulesService{
  serverURL = environment.serverUrl;
  constructor(private httpClient:HttpClient){}
  addRoutingRule(ruleDetails){
    return this.httpClient.post(this.serverURL+"routing-rule/add-rule/",ruleDetails)
  }
  getRoutingRule(clientId){
    return this.httpClient.get(this.serverURL+"routing-rule/get-rules/"+clientId)
  }
  updateRoutingRule(clientId,ruleId,updatedRule){
    return this.httpClient.put(this.serverURL+"routing-rule/update-rule/"+clientId+"/"+ruleId,updatedRule)
  }
  deleteRoutingRule(clientId,ruleId){
    return this.httpClient.delete(this.serverURL+"routing-rule/delete-rule/"+clientId+"/"+ruleId)
  }
  changeActiveStatus(clientId,ruleId,status){
    return this.httpClient.put(this.serverURL+"routing-rule/update-active-status/"+clientId+"/"+ruleId,status)
  }
}
